import Pusher from "pusher-js";
import { fetcher as client } from "@/shared/lib/fetcher.client";

export type BrowserSessionState = {
  channel: string
  server_time: number
  last_activity_at: number
  warning_deadline: number | null
  absolute_deadline: number
  revoked: boolean
};

export async function synchronizeSession(activity = false): Promise<BrowserSessionState | null> {
  const response = await client.post<BrowserSessionState>("/oauth/session", { activity });
  return response.status === 204 ? null : response.data;
}

export function watchSession(channelName: string, changed: () => void): () => void {
  const pusher = new Pusher(import.meta.env.VITE_PUSHER_KEY, {
    cluster: import.meta.env.VITE_PUSHER_CLUSTER,
    channelAuthorization: {
      transport: "ajax",
      endpoint: "/oauth/session/pusher/auth",
      customHandler: ({ socketId, channelName: name }, callback) => {
        client.post("/oauth/session/pusher/auth", { socket_id: socketId, channel_name: name })
          .then(({ data }) => callback(null, data))
          .catch(() => callback(new Error("Session channel authorization failed"), null));
      },
    },
  });
  const channel = pusher.subscribe(channelName);
  // Payloads are deliberately ignored: only the API can authorize a reset.
  channel.bind("session_changed", changed);
  channel.bind("pusher:subscription_succeeded", changed);
  return () => pusher.disconnect();
}
